import axios from 'axios';
import { createUserSuccess, createUserFailure, editUserSuccess, editUserFailure, changePasswordSuccess, changePasswordFailure, deleteUserSuccess, deleteUserFailure } from './userSlice'; // Import failure action
import { API_BASE_URL } from '../config/config';

export const createUser = (newUserData) => async (dispatch, getState) => {
  try {
    const { token } = getState().user; // Get token from Redux state

    const response = await axios.post(`${API_BASE_URL}api/users/create`, newUserData, {
      headers: { Authorization: `Bearer ${token}` }, // Send JWT for authorization
    });

    // Dispatch the created user to Redux store
    dispatch(createUserSuccess(response.data));
  } catch (error) {
    // Dispatch failure action with error message
    dispatch(createUserFailure(error.response.data.message || 'Failed to create user'));

    // Optionally throw the error to handle it in the component
    throw error;
  }
};
export const editUser = (userId, updatedData) => async (dispatch, getState) => {
  try {
    const { token } = getState().user;

    const response = await axios.patch(`${API_BASE_URL}api/users/${userId}/edit`, updatedData, {
      headers: { Authorization: `Bearer ${token}` },
    });

    dispatch(editUserSuccess(response.data));
  } catch (error) {
    dispatch(editUserFailure(error.response.data.message || 'Failed to update user details'));
    throw error;
  }
};

export const deleteuser = (userId) => async (dispatch, getState) => {
  try {
    const { token } = getState().user;

    await axios.delete(`${API_BASE_URL}api/users/${userId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    dispatch(deleteUserSuccess());
  } catch (error) {
    dispatch(deleteUserFailure(error.response.data.message || 'Failed to delete user'));
    throw error;
  }
};

// Change user password
export const changeUserPassword = (userId, newPassword) => async (dispatch, getState) => {
  try {
    const { token } = getState().user;

    await axios.patch(`${API_BASE_URL}api/users/${userId}/change-password`, { newPassword }, {
      headers: { Authorization: `Bearer ${token}` },
    });

    dispatch(changePasswordSuccess());
  } catch (error) {
    dispatch(changePasswordFailure(error.response.data.message || 'Failed to change password'));
    throw error;
  }
};